module.exports = __webpack_public_path__ + "static/media/awardslogo.02e6154b.png";